import { clsx } from 'clsx';

import { DynamicIndicator } from '../../../views/common/DynamicIndicator/DynamicIndicator';
import classes from './BasicHighlight.module.scss';
import { IHighlight } from '../../interfaces';
import { BasicTooltip } from '../BasicTooltip/BasicTooltip';
import { StarIcon } from '../../../assets/icons/StarIcon';
import { toPrettyNumber } from '../../../utils/commonUtils';
import { Typography } from '../../../shared/ui/typography';
import { AlertIcon } from '../../../assets/icons/AlertIcon';
import { HigherIcon } from '../../../assets/icons/HigherIcon';
import { useSelector } from 'react-redux';
import { isMobileModeSelector } from '../../../redux/selectors/appStatusSelector';

export const Highlight = ({
  changeValueColor = false,
  className,
  label,
  rating = false,
  reverse = false,
  showDynamicIndicator = true,
  tooltip,
  value = 0,
  previousValue,
  isDecimal,
  currency,
  showAlertIcon = false,
  showHigherIcon = false,
}: IHighlight) => {
  const isMobileView = useSelector(isMobileModeSelector);
  const preparedNumber = isDecimal
    ? Number(value).toFixed(1)
    : Number(value).toFixed(0);
  const number = currency ? toPrettyNumber(value) : preparedNumber;

  const highlightValue = (
    <div className={classes.highlightValueContainer}>
      {showAlertIcon && <AlertIcon />}
      {showHigherIcon && <HigherIcon />}
      <Typography
        weight='semibold'
        variant={isMobileView ? 'display-xs' : 'display-sm'}
        className={clsx(
          classes.highlightValue,
          changeValueColor ? classes.greenPrimary : ''
        )}
      >
        {number}
      </Typography>
      {rating && <StarIcon />}
      {showDynamicIndicator && (
        <div className={classes.dynamicIndicator}>
          {value && previousValue ? (
            <DynamicIndicator previous={previousValue} current={value} />
          ) : null}
        </div>
      )}
    </div>
  );
  const highlightLabel = (
    <div className={classes.highlightLabelWithTooltip}>
      <Typography variant='text-md' className={classes.highlightLabel}>
        {label}
      </Typography>
      {tooltip && <BasicTooltip tooltip={tooltip} />}
    </div>
  );

  return (
    <div className={`${classes.highlight} ${className}`}>
      {reverse ? (
        <>
          {highlightLabel}
          {highlightValue}
        </>
      ) : (
        <>
          {highlightValue}
          {highlightLabel}
        </>
      )}
    </div>
  );
};
